<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <LoadingBar
      v-if="loading === true || error.message.length"
      :error="error.message"
    />
    <ve-stepper v-model="currentStep" horizontal v-else>
      <v-stepper-items>
        <v-stepper-header
          style="display: flex; 
          align-items: center; 
          justify-content: center; 
          width: 75%; margin: auto; 
          border: none; 
          box-shadow: none;"
        >
          <template v-for="(step, n) in newSteps">
            <ve-stepper-step
              :key="`step-${n}`"
              :complete="currentStep > n + 1"
              :step="n + 1"
              class="py-2"
              style="position: relative; border-radius: 18px;"
            >
              <div
                v-if="n === 0"
                style="position: absolute; left: 15px; top: 10%; padding: 10px; border-radius: 50%; background-color: #E0E0E7;"
                :style="{
                  backgroundColor: currentStep > n ? '#2B5B3C' : '#808080'
                }"
              >
                <v-img
                  src="@/assets/sample-info-icon.svg"
                  style="width: 13px; height: 13px; background-color: #E0E0E7;"
                  alt="icon"
                ></v-img>
              </div>

              <div
                v-if="n === 1"
                style="position: absolute; left: 15px; top: 10%; padding: 10px; border-radius: 50%; background-color: #E0E0E7;"
                :style="{
                  backgroundColor: currentStep > n ? '#2B5B3C' : '#808080'
                }"
              >
                <v-img
                  src="@/assets/test-incomplete.svg"
                  style="width: 13px; height: 13px;"
                  alt="icon"
                ></v-img>
              </div>

              <div
                v-if="n === 2"
                style="position: absolute; left: 15px; top: 10%; padding: 10px; border-radius: 50%; background-color: #E0E0E7;"
                :style="{
                  backgroundColor: currentStep > n ? '#2B5B3C' : '#808080'
                }"
              >
                <v-img
                  src="@/assets/test-incomplete.svg"
                  style="width: 13px; height: 13px;"
                  alt="icon"
                ></v-img>
              </div>

              <div
                v-if="n === 3"
                style="position: absolute; left: 15px; top: 10%; padding: 10px; border-radius: 50%; background-color: #E0E0E7;"
                :style="{
                  backgroundColor: currentStep > n ? '#2B5B3C' : '#808080'
                }"
              >
                <v-img
                  src="@/assets/test-incomplete.svg"
                  style="width: 13px; height: 13px;"
                  alt="icon"
                ></v-img>
              </div>

              <div
                v-if="n === 4"
                style="position: absolute; left: 15px; top: 10%; padding: 10px; border-radius: 50%; background-color: #E0E0E7;"
                :style="{
                  backgroundColor: currentStep > n ? '#2B5B3C' : '#808080'
                }"
              >
                <v-img
                  src="@/assets/review-incomplete.svg"
                  style="width: 13px; height: 13px;"
                  alt="icon"
                ></v-img>
              </div>

              <div
                v-if="n === 5"
                style="position: absolute; left: 15px; top: 10%; padding: 10px; border-radius: 50%; background-color: #E0E0E7;"
                :style="{
                  backgroundColor: currentStep > n ? '#2B5B3C' : '#808080'
                }"
              >
                <v-img
                  src="@/assets/shipping-incomplete.svg"
                  style="width: 13px; height: 13px;"
                  alt="icon"
                ></v-img>
              </div>
              <v-stepper-item>
                {{ step.title }}
              </v-stepper-item>
            </ve-stepper-step>
            <v-divider
              :key="`step-divider-${n}`"
              style="background-color: #2B5B3C;"
              v-if="n < newSteps.length - 1"
            ></v-divider>
          </template>
        </v-stepper-header>
        <template v-for="(step, n) in newSteps">
          <!-- <v-stepper-step :key="`step-${n}`" :complete="currentStep > n" :step="n + 1" class="py-2">
            {{ step.title }}
          </v-stepper-step> -->
          <v-stepper-content
            :key="`step-content-${n}`"
            :step="n + 1"
            style="margin-top: 4rem;"
          >
            <!-- <div>{{ active_sample }}</div> -->
            <!-- <div>{{ active_sample.shipment_id }}</div>

            <div>activeSampleShipmentId {{ activeSampleShipmentId }}</div>

            <div>{{ active_sample.id }}</div> -->

            <!-- <div>This is step {{ currentStep }}</div>
            <div>Shipment id {{ activeSampleShipmentId }}</div> -->

            <!-- 
            <div>{{ active_sample.shipment }}</div>
            <div>{{ active_sample.shipments }}</div> -->
            <!-- <div>{{ active_sample.shipment._joinData.shipment_id }}</div> -->

            <div class="v-footer no-gutters" style="margin-bottom: 40px;">
              <LoadingBar v-if="loading === true" />
              <template v-else>
                <v-row no-gutters dense>
                  <v-col>
                    <v-btn
                      v-if="currentStep > 1"
                      color="primary"
                      :disabled="previousLoading"
                      @click="previousStep"
                      id="prev-1"
                    >
                      <template v-if="previousLoading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>
                      <template v-else>
                        Previous
                      </template>
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-col>
                </v-row>
                <v-row no-gutters dense>
                  <v-col>
                    <v-btn
                      v-if="routeSampleId && currentStep !== newSteps.length"
                      color="primary"
                      @click="saveAndExit(n + 1)"
                      :disabled="!canContinue || continueLoading"
                      class="float-right mb-1 ml-2"
                      id="save-exit-1"
                    >
                      <template v-if="continueLoading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>
                      <template v-else>
                        Save and Exit
                      </template>
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="nextStep(n + 1)"
                      :disabled="!canContinue || continueLoading"
                      class="float-right mb-1 ml-2"
                      id="next-1"
                    >
                      <template v-if="continueLoading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>
                      <template v-else>
                        {{ nextStepBtnLabel }}
                      </template>
                    </v-btn>
                    <v-btn
                      v-if="
                        !routeSampleId &&
                          currentStep === newSteps.length &&
                          !isBulk
                      "
                      @click="addAnotherSample()"
                      color="primary"
                      class="float-right mb-1 ml-2"
                      id="add-another-1"
                    >
                      Add Another Sample
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </div>
            <component
              v-bind:is="step.component"
              :ref="step.component"
              v-if="currentStep === n + 1"
              :halt="halt"
              style="box-shadow: none !important; border: none !important;"
              @number-of-samples-modal-opened="onNumberOfSamplesModalOpened"
            />
            <div class="v-footer no-gutters">
              <LoadingBar v-if="loading === true" />
              <template v-else>
                <v-row no-gutters dense>
                  <v-col>
                    <v-btn
                      v-if="currentStep > 1"
                      color="primary"
                      :disabled="previousLoading"
                      @click="previousStep"
                      id="prev-2"
                    >
                      <template v-if="previousLoading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>
                      <template v-else>
                        Previous
                      </template>
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-col>
                </v-row>
                <v-row no-gutters dense>
                  <v-col>
                    <v-btn
                      v-if="routeSampleId && currentStep !== newSteps.length"
                      color="primary"
                      @click="saveAndExit(n + 1)"
                      :disabled="!canContinue || continueLoading"
                      class="float-right mb-1 ml-2"
                      id="save-exit-2"
                    >
                      <template v-if="continueLoading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>
                      <template v-else>
                        Save and Exit
                      </template>
                    </v-btn>
                    <v-btn
                      color="primary"
                      @click="nextStep(n + 1)"
                      :disabled="!canContinue || continueLoading"
                      class="float-right mb-1 ml-2"
                    >
                      <template v-if="continueLoading">
                        <v-progress-circular
                          indeterminate
                          size="20"
                          width="3"
                          color="white"
                        />
                      </template>
                      <template v-else>
                        {{ nextStepBtnLabel }}
                      </template>
                    </v-btn>
                    <v-btn
                      v-if="
                        !routeSampleId &&
                          currentStep === newSteps.length &&
                          !isBulk
                      "
                      @click="addAnotherSample()"
                      color="primary"
                      class="float-right mb-1 ml-2"
                      id="add-another-2"
                    >
                      Add Another Sample
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </div>
          </v-stepper-content>
        </template>
      </v-stepper-items>
    </ve-stepper>
    <v-dialog v-model="refIdReminder" :width="isBulk ? 700 : 600" persistent>
      <v-card style="overflow-x: hidden;">
        <v-card-title>Please Note</v-card-title>
        <v-row style="padding: 0 1rem 0 0.5rem;" v-if="!isBulk">
          <v-col>
            <v-card-text>
              <p><b>Lab ID:</b> {{ active_sample.slug }}</p>
              <p>
                Please make sure that sample has been added to sample bag
                {{ active_sample.sample_bag_barcode }} and the barcode is added
                on it correctly
              </p>

              <p style="width: 25rem;">
                Please include sample lab Id or Sample Bag Barcode on your paper
                work and write it on the sample bag
              </p>
            </v-card-text>
          </v-col>
          <v-col>
            <v-img
              src="@/assets/shopping-bag-512.png"
              alt="bag-icon"
              style="width: 100px; margin-left: auto;"
            />
          </v-col>
        </v-row>
        <v-row style="padding: 0 1rem 0 0.5rem;" v-else>
          <v-col>
            <v-card-text>
              <v-row style="text-wrap: nowrap; flex-wrap: nowrap;">
                <v-col style="font-weight: bold;">Lab ID Start:</v-col>
                <v-col>{{ lab_id_start }}</v-col>
                <v-col style="font-weight: bold;">Lab ID End:</v-col>
                <v-col>{{ lab_id_end }}</v-col>
              </v-row>
              <v-row style="text-wrap: nowrap; flex-wrap: nowrap;">
                <v-col style="font-weight: bold;">Start Bag Barcode:</v-col>
                <v-col>{{ barcode_start }}</v-col>
                <v-col style="font-weight: bold;">End Bag Barcode:</v-col>
                <v-col>{{ barcode_end }}</v-col>
              </v-row>
            </v-card-text>
            <p style="padding-left: 1rem; text-wrap: wrap;">
              Please make sure that samples have been added to its sample bag
              and the barcode is added on it correctly
            </p>
            <p style="padding-left: 1rem; text-wrap: wrap;">
              Please include sample lab Id or Sample Bag Barcode on your paper
              work and write it on the sample bag
            </p>
          </v-col>
          <v-col>
            <v-img
              src="@/assets/shopping-bag-512.png"
              alt="bag-icon"
              style="width: 100px; margin-left: auto;"
            />
          </v-col>
        </v-row>
        <v-card-actions>
          <v-btn
            @click="handlleClickCancel"
            style="margin-left: 8px;"
            id="cancel-btn"
            >Cancel</v-btn
          >
          <v-spacer />
          <v-btn
            color="primary"
            @click="nextStep(currentStep)"
            :disabled="!canContinue"
            class="mb-1 ml-2"
            id="finish-btn"
          >
            Finish
          </v-btn>

          <v-btn
            v-if="routeSampleId && currentStep !== newSteps.length"
            color="primary"
            @click="saveAndExit(currentStep)"
            :disabled="!canContinue"
            class="mb-1 ml-2"
            id="save-exit-modal"
          >
            Save and Exit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { getForm } from "@/utils";
import LoadingBar from "@/components/loaders/LoadingBar";
import PackageSelectionStep from "@/components/newSamples/SampleWizardSteps/PackageSelectionStep";
import BillingStep from "@/components/newSamples/SampleWizardSteps/BillingStep";
import SampleInformationStep from "@/components/newSamples/SampleWizardSteps/SampleInformationStep";
import ReviewStep from "@/components/newSamples/SampleWizardSteps/ReviewStep";
import ShipmentSelectionStep from "@/components/newSamples/SampleWizardSteps/ShipmentSelectionStep";
import ImagingStep from "@/components/newSamples/SampleWizardSteps/ImagingStep";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import hasIn from "lodash.hasin";
import VeStepper from "@/components/VeStepper";
import VeStepperStep from "@/components/VeStepper/VeStepperStep";

/**
 * @property {int} currentStep
 */
export default {
  name: "SampleWizard",
  components: {
    LoadingBar,
    PackageSelectionStep,
    BillingStep,
    SampleInformationStep,
    ReviewStep,
    ShipmentSelectionStep,
    ImagingStep,
    VeStepper,
    VeStepperStep
  },
  data() {
    return {
      loading: false,
      continueLoading: false,
      previousLoading: false,
      ExitAfterSave: false,
      refIdReminder: false,
      valid: false, // This gets updated automatically, via the validator
      halt: false, // Allows a child component to halt continue by emitting updateHalt
      addAnother: false,
      isEdit: window.location.pathname.includes("sample-edit")
    };
  },
  computed: {
    ...mapGetters("sampleWizard", ["newSteps", "currentNewStepComponentTitle"]),
    ...mapGetters("clients", ["selectedClient"]),
    ...mapState("samples", ["active_sample"]),
    ...mapState("copyTo", { copyTos: "items" }),
    ...mapState("auth", ["user"]),
    ...mapFields("sampleWizard", [
      "wizard.currentStep",
      "wizard.returnStep",
      "wizard.isBulk",
      "wizard.sampleIds",
      "wizard.prepopulatePackagesAndComponents",
      "wizard.barcode_start",
      "wizard.barcode_end",
      "wizard.lab_id_start",
      "wizard.lab_id_end",
      "wizard.disableLabField",
      "wizard.error"
    ]),
    ...mapFields("samples", [
      "billingAgree",
      "active_sample",
      "active_sample.number_of_samples",
      "active_sample.sample_bag_barcode"
    ]),
    // Returns the current step component instance
    currentStepComponent() {
      if (!this.$refs) return undefined;
      // Find the current component (by ref="componentName")
      // currentStep is ahead of the index by 1
      let component = this.$refs[this.currentNewStepComponentTitle];
      if (!component) return undefined;
      if (Array.isArray(component)) {
        // The component will most likely be in an array, but it'll only have one item in it
        component = component[0];
      }
      return component;
    },
    canContinue() {
      if (this.error.message.length) {
        return false;
      }
      return this.valid;
    },
    nextStepBtnLabel() {
      if (this.currentStep === this.newSteps.length) return "Finished";
      return "Continue";
    },
    activeSampleShipmentId() {
      return this.active_sample && this.active_sample.shipment_id
        ? this.active_sample.shipment_id
        : this.active_sample.shipment
        ? this.active_sample.shipment.id
        : null;
    },
    routeSampleId() {
      return hasIn(this.$route, "params.sampleId")
        ? this.$route.params.sampleId
        : null;
    }
  },
  watch: {
    "$route.path": {
      handler(newPath) {
        if (
          newPath.includes("bulk-sample-wizard") ||
          newPath.includes("/sample-wizard")
        ) {
          this.active_sample.test_packages = [];
          this.active_sample.test_components = [];
        }
        if (newPath.includes("bulk-sample-wizard")) {
          this.isBulk = true;
          this.sampleIds = [];
          this.prepopulatePackagesAndComponents = false;
        } else this.isBulk = false;
        this.sampleIds = [];
        this.active_sample.id = null;
        this.active_sample.number_of_samples = 0;
        this.active_sample.sample_bag_barcode = null;
        this.active_sample.barcode_start = null;
        this.active_sample.barcode_end = null;
        this.active_sample.slug = null;
        this.active_sample.feed_type_id = null;
        this.addAnother = false;
        this.active_sample.description = null;
        this.active_sample.farms_source_id = null;
        this.active_sample.feed_type_id = null;
        this.active_sample.cutting = "";
        this.active_sample.sample_condition = "";
        this.active_sample.date_collected = "";
        this.active_sample.copy_to = [];
        this.active_sample.crop_year = null;
        this.active_sample.is_preground = false;
        this.currentStep = 1;
      },
      immediate: true
    },
    currentStep() {
      this.active_sample.number_of_samples =
        !!this.sampleIds && this.sampleIds?.length
          ? this.sampleIds?.length
          : this.active_sample.number_of_samples;
    },
    isBulk() {
      getForm(this).resetValidation();
      this.active_sample.id = null;
      this.disableLabField = false;
      this.returnStep = false;
    },
    selectedClient(value) {
      getForm(this).resetValidation();
      Promise.all([this.getCopyTos({ client_id: value.id })]).then(data => {
        // Check for errors from any promise
        if (data.includes(false)) {
          this.error.message = "An error occurred while retrieving this sample";
        }
      });
    }
  },
  methods: {
    ...mapActions("samples", [
      "setActive",
      "logSampleTransaction",
      "addBulkSamples"
    ]),
    ...mapActions("samples", ["setActive"]),
    ...mapActions("samples", ["logSampleTransaction"]),
    ...mapActions("copyTo", ["getCopyTos"]),
    ...mapActions("baseData", [
      "getLabs",
      "getTestPackageCategories",
      "getPackages",
      "getComponentCategories",
      "getTestComponents",
      "getFeedTypes",
      "getFeedClasses",
      "getCalibrateIngredients"
    ]),
    ...mapActions(["notify"]),
    ...mapActions("farms", ["getActiveFarms"]),
    ...mapActions("labs", ["getClientLabs"]),
    ...mapMutations("samples", ["clearActive"]),
    ...mapMutations("sampleWizard", ["resetWizard"]),
    async previousStep() {
      this.previousLoading = true;
      this.returnStep =
        this.currentStep !== this.newSteps?.length
          ? this.currentStep
          : this.returnStep;
      await this.$nextTick();
      await new Promise(resolve => setTimeout(resolve, 500));
      this.currentStep--;
      this.previousLoading = false;
      this.returnStep = false;
    },
    // Proceed to the next step
    nextStep(n, cb = undefined) {
      if (!this.$refs.form.validate()) return false;
      if (this.currentNewStepComponentTitle === "ReviewStep") {
        this.refIdReminder = !this.refIdReminder;
      }
      if (this.refIdReminder) return false;
      if (this.active_sample && this.active_sample.id) {
        console.log(
          `Sample with id ${this.active_sample.id} was edited successffuly`
        );
        this.logSampleTransaction({
          logData: this.active_sample,
          user: this.user.id,
          scope: "samples-api"
        });
      } else if (
        this.currentStep == 1 &&
        this.active_sample &&
        !this.active_sample.id
      ) {
        this.logSampleTransaction({
          logData: this.active_sample,
          user: this.user.id,
          scope: "samples-api"
        });
        console.log(`Sample was created succesffuly`);
        console.log(`Lab Id ${this.active_sample.lab_id}`);
        console.log(`Client Id ${this.active_sample.client_id}`);
        console.log(`Farm Id ${this.active_sample.lab_id}`);
        console.log(`Farm Id ${this.active_sample.farm_id}`);
        console.log(
          `Sample Bag Barcode ${this.active_sample.sample_bag_barcode}`
        );
        console.log(`Feed Source Id ${this.active_sample.farms_source_id}`);
        console.log(`Feed Type Id ${this.active_sample.feed_type_id}`);
        console.log(`Description ${this.active_sample.description}`);
        console.log(`Feed Source Id ${this.active_sample.farms_source_id}`);
      }
      // If component has beforeContinue method, execute it. Otherwise, we can safely set to true.
      const beforeContinue =
        this.currentStepComponent && this.currentStepComponent.beforeContinue
          ? this.currentStepComponent.beforeContinue()
          : true;
      this.continueLoading = beforeContinue;
      // Resolve as a promise, that way we can do async things when needed
      Promise.resolve(beforeContinue).then(res => {
        // As long as we don't have a false response, we can proceed to the next step
        if (res) {
          this.continueLoading = false;
          // If returnStep contains a step, go to that step
          if (
            this.returnStep &&
            typeof this.returnStep === "number" &&
            !this.ExitAfterSave
          ) {
            this.currentStep = this.returnStep;
            this.returnStep = false; // Reset returnStep value
            return true;
          }
          // Default to next step iteration
          this.currentStep = n + 1;
          this.disableLabField = true;

          if (this.currentStep > this.newSteps.length) {
            this.continueLoading = false;
            // const shipmentId = this.activeSampleShipmentId;
            // Sample submitted. Clear active_sample and reset wizard
            // this.clearActive();
            // this.resetWizard();
            // Only issue redirect if a callback wasn't defined
            if (typeof cb !== "function") {
              let message = "Sample Data Added Successfully";
              if (this.addAnother) {
                this.currentStep = 1;
                this.active_sample.sample_bag_barcode = null;
                this.active_sample.id = null;
                this.active_sample.slug = null;
                this.active_sample.feed_type_id = null;
                this.disableLabField = false;
                this.addAnother = false;
                this.active_sample.description = null;
                this.active_sample.farms_source_id = null;
                this.active_sample.feed_type_id = null;
                this.active_sample.copy_to = [];
                this.active_sample.crop_year = null;
                this.active_sample.cutting = "";
                this.active_sample.sample_condition = "";
                this.active_sample.date_collected = "";
                this.active_sample.is_preground = false;
              } else {
                this.prepopulatePackagesAndComponents = false;
                this.clearActive();
                this.$router.push({
                  path: "/samples/browse"
                });
                if (!this.isEdit && !this.isBulk) {
                  this.notify({
                    message,
                    actionClickHandler: () => {
                      this.prepopulatePackagesAndComponents = true;
                      this.$router.push("/samples/sample-wizard");
                    },
                    timeout: 2000
                  });
                } else {
                  this.prepopulatePackagesAndComponents = false;
                  this.notify({
                    message: "Sample Data Edited Successfully",
                    timeout: 2000
                  });
                }
              }
            }
          }
          // execute the callback if one was provided
          if (typeof cb === "function") cb();
        } else {
          this.continueLoading = false;
        }
      });
    },
    saveAndExit(step) {
      this.ExitAfterSave = true;
      this.nextStep(step, () => {
        this.clearActive();
        this.resetWizard();
        this.ExitAfterSave = false;
        this.prepopulatePackagesAndComponents = false;
        this.$router.push("/samples/browse");
      });
    },
    addAnotherSample() {
      this.addAnother = true;
      this.refIdReminder = true;
    },
    handlleClickCancel() {
      this.refIdReminder = false;
      this.addAnother = false;
    },
    onNumberOfSamplesModalOpened() {
      getForm(this).resetValidation();
    }
  },
  mounted() {
    this.loading = true;
    this.error.message = "";
    if (this.user.is_copy_to) {
      this.error.message = "Report Recipient has no access to this page";
      return;
    }

    if (this.routeSampleId) {
      this.billingAgree = true;
      localStorage.setItem("stored_step", this.routeSampleId);
      if (this.routeSampleId !== localStorage.getItem("stored_step")) {
        this.currentStep = 1;
      }
    } else {
      this.currentStep = 1;
    }

    Promise.all([
      this.getLabs(),
      this.getClientLabs(this.selectedClient.id),
      this.getTestPackageCategories(),
      this.getPackages(),
      this.getComponentCategories(),
      this.getTestComponents(),
      this.getCopyTos({ client_id: this.selectedClient.id }),
      this.getActiveFarms(this.selectedClient.id),
      this.getFeedTypes(),
      this.getFeedClasses(),
      this.getCalibrateIngredients(),
      // Initialize active sample
      this.setActive(this.routeSampleId)
    ]).then(data => {
      // Check for errors from any promise
      if (data.includes(false)) {
        this.error.message = "An error occurred while retrieving this sample";
      }
      this.disableLabField =
        this.active_sample.lab_id !== null && this.active_sample.id !== null;
      this.loading = false;
    });
  }
};
</script>
